var Marionette = require('backbone.marionette');
var RelationTypesCollection = require('../../collections/relation-types-collection');
var RelationTypeModel = require('../../models/relation-type-model');


var RelationsTypesSelect = Marionette.View.extend({
    template: require('../../templates/relations/relations-types-select.html'),
    collection: new RelationTypesCollection(),
    selectedType: new RelationTypeModel(),
    events: {
        'change #relation-type': 'typeSelected'
    },

    collectionEvents: {
        request: 'showLoading',
        sync: 'hideLoading',
        error: 'logError'
    },

    initialize: function(options){
        _.bindAll(this, 'onRender', 'typeSelected', 'getEntityType');
        if (options){
            this.reversed = options.reversed;
            this.selectedType.set('id', options.type);
            var collectionParams = [];
            if(options.types && options.types.length > 0){
                var typeParams = options.types.map(function(type){
                    return {key: 'type', value: type}
                });
                collectionParams = collectionParams.concat(typeParams);
            }
            if(options.childrenTypes && options.childrenTypes.length > 0){
                var childrenTypes = options.childrenTypes.map(function(type){
                    return {key: 'childType', value: type}
                });
                collectionParams = collectionParams.concat(childrenTypes);
            }
            if(options.parentTypes && options.parentTypes.length > 0){
                var parentTypes = options.parentTypes.map(function(type){
                    return {key: 'parentType', value: type}
                });
                collectionParams = collectionParams.concat(parentTypes);
            }
            this.collection = new RelationTypesCollection([], {params: collectionParams});
            this.collection.fetch({success: this.render});
        }
    },

    onRender: function() {
        this.$('#relation-type').selectize({
            allowEmptyOption: false
        });
    },

    typeSelected: function (event) {
        this.selectedType.set('id', event.target.value);
        this.triggerMethod('type:selected', {
            relationType: event.target.value,
            entityType: this.getEntityType(event.target.value)
        });
    },

    getEntityType: function (relationType) {
        var result = this.collection.find(function(model){return relationType === model.get('id')});
        if (result){
            return  this.reversed ? result.get('parentType') :result.get('childType')
        }
        return undefined;
    },

    showLoading: function() {
        this.$('.loading').show();
    },

    hideLoading: function() {
        this.$('.loading').hide();
    },

    logError: function(obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    }
});

module.exports = RelationsTypesSelect;


//////////////////
// WEBPACK FOOTER
// ./app/views/relations/relations-types-select.js
// module id = 222
// module chunks = 0